import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthorizationService } from '@core/authorization/services/authorization.service';

export const redirectMigratedUserGuard =
  (commands: string[]): CanMatchFn =>
  () => {
    const authorizationService = inject(AuthorizationService);
    const router = inject(Router);

    if (authorizationService.isMigratedUser()) {
      return router.createUrlTree(commands);
    }

    return false;
  };
